import React, { useEffect, useState } from "react";
import "./css/StatusPage.css";

export const StatusPage: React.FC = () => {
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsChecking(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="status-container">
            <h1 className="status-title">System Status</h1>

            {isChecking ? (
                <div className="status-block">
                    <div className="spinner" />
                    <p className="status-message">Checking Skitterbook status…</p>
                </div>
            ) : (
                <div className="status-block">
                    <div className="success-icon" />
                    <p className="status-success">Skitterbook is running</p>                    
                </div>
            )}

            <div className="status-block">
                <p className="status-info">
                    If things take a moment to load, it may simply be because Skitterbook is waking up in the background.
                    This can cause a short delay, but everything should be ready shortly. Thankyou for your patience.
                </p>
            </div>
        </div>
    );
};

export default StatusPage;
